<template>
  <div class="home">
    <b-row>
      <b-col>
        <ApplicationTitle />
      </b-col>
      <b-col v-if="isThereNews" md="12" lg="3" class="text-left">
        <News :items="news" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import ApplicationTitle from '@/components/ApplicationTitle.vue';

import News from '@/components/News.vue';

import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    ApplicationTitle,
    News,
  },
  computed: mapState(['news', 'isThereNews']),
};
</script>
